<template>
  <div v-if="show" class="contact-store-wrapper">
    <el-popover v-model="visible" placement="top" width="228" trigger="hover">
      <p>确定要与患者视频沟通？单次沟通最多不可超过10分钟</p>
      <div style="text-align: center; margin-top: 12px">
        <el-button plain size="mini" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="_contactStore">确定</el-button>
      </div>
      <div slot="reference">
        <img class="img" :src="require(`@/assets/img/${imgSrc}.png`)" alt="" />
        <p>{{ imgSrc == 'contact_clerk' ? '联系店员' : '联系药师' }}</p>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { isEmpty } from '@/util';
import { mapState } from 'vuex';
export default {
  name: 'contactStore',
  props: {
    prescriptionDetail: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 1:从全部处方来，2:从待处理来
    from: {
      type: String,
      default: '1'
    }
  },
  computed: {
    ...mapState('video', ['isCallReceived', 'callDuration', 'isBeCalling', 'isCallAccepted']),
    show() {
      const { from } = this;
      // 全部处方，医生审核通过后展示
      if (from == 1) {
        const { doctorAuditStatus } = this.prescriptionDetail;
        return doctorAuditStatus == 1;
      }
      // 待审核处方，可审核的时候展示
      return from == 2;
    },
    imgSrc() {
      let { from } = this;
      // 全部处方展示联系药师
      if (from == 1) return 'contact_phar';
      // 待审处方展示联系店员
      if (from == 2) return 'contact_clerk';
      return 'contact_clerk';
    }
  },
  watch: {
    callDuration(newVal, oldVal) {
      if (newVal == 585) {
        this.$store.dispatch('video/setVideoWarning', { show: true }); // todo: lhh  trtc组件超时也可以调用这一行
      }
    }
  },
  data() {
    return {
      visible: false,
      videoWarningShow: false,
      callAccount: null
    };
  },
  methods: {
    async _contactStore() {
      const { id: prescriptionId } = this.prescriptionDetail;
      if (isEmpty(prescriptionId)) return;
      this.$store.commit('prescription/SET_CONTACT_STORE_PID', prescriptionId);
      this.$store.dispatch('prescription/contactStore', { connectType: this.from });
    }
  }
};
</script>

<style lang="less" scoped>
.contact-store-wrapper {
  .el-popover__reference {
    display: inline-flex;
    align-items: center;
    color: #707070;
    .img {
      height: 19px;
      width: 21px;
      margin-right: 7px;
    }
  }
}
</style>
